export default __webpack_public_path__ + "static/media/bitmap@5x.3a73f92d.png";